<template>
  <div class="floating-ask-ai-wrapper" @click="onClose" @keydown="onKeydown">
    <div @click.stop class="ai-dropdown" :style="getDropdownStyle">
      <AskAiInput
        ref="chatgptInputRef"
        :processId="processId"
        :taskId="task.id"
        :elements="elements"
        :isLoading="isLoading"
        :selectedId="selectedId"
        @submit="handleAPIcall"
      />
    </div>
  </div>
</template>

<script>
import {
  executeAIGeneratedStyle,
  handleAskAI,
  getParsedAIResponse,
  createAIGeneratedEntry,
} from '@/utils/helpers/FormBuilderHelper.js';

import AskAiInput from '@/components/FormBuilder/AskAI/AskAiInput.vue';
export default {
  name: 'FloatingAskAiDropdown',
  data() {
    return {
      error: null,
      isLoading: false,
    };
  },
  props: {
    selectedId: {
      type: String,
      default: '',
    },
    processId: {
      type: String,
      required: true,
    },
    task: {
      type: Object,
      default: () => {},
    },
    flowRunnerEndpoint: {
      type: String,
    },
    elements: {
      type: Array,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    editTaskIndex: {
      type: [Number, null],
      default: null,
    },
  },

  methods: {
    onClose() {
      if (this.isLoading) return;
      this.$emit('onClose');
    },
    onKeydown(e) {
      if (e.code == 'Escape') {
        this.onClose();
      }
    },
    async handleAPIcall(prompt) {
      if (this.isLoading || !prompt) return;
      this.error = '';
      this.isLoading = true;

      try {
        const response = await handleAskAI(
          this.task,
          prompt,
          this.flowRunnerEndpoint,
          this.selectedId,
          this.isEditMode ? this.editTaskIndex : null
        );
        const parseRes = getParsedAIResponse(response, this.task);
        if (this.isEditMode && this.editTaskIndex !== null) {
          const prevEntry = this.task.props.settings.aiGenerated[this.editTaskIndex];
          this.$set(this.task.props.settings.aiGenerated, this.editTaskIndex, {
            id: prevEntry?.id || `ai-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
            createdAt: prevEntry?.createdAt || new Date().toISOString(),
            targetElementId: this.selectedId || prevEntry?.targetElementId || null,
            ...parseRes,
            prompt,
          });
        } else if (
          !('aiGenerated' in this.task.props.settings) ||
          !Array.isArray(this.task.props.settings.aiGenerated)
        ) {
          this.$set(this.task.props.settings, 'aiGenerated', [
            createAIGeneratedEntry(parseRes, prompt, this.selectedId),
          ]);
        } else {
          this.task.props.settings.aiGenerated.push(
            createAIGeneratedEntry(parseRes, prompt, this.selectedId)
          );
        }

        executeAIGeneratedStyle(this.getStyles);

        this.$emit('onClose');
      } catch (error) {
        this.error = error.message;
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    getDropdownStyle() {
      const ele = document.getElementById(this.selectedId);
      if (!ele) return {};

      const rect = ele.getBoundingClientRect();

      const windowHeight = window.innerHeight;

      if (rect.top < windowHeight / 2) {
        return {
          top: rect.top + 'px',
          left: rect.left + 'px',
        };
      } else {
        return {
          bottom: windowHeight - rect.bottom + 'px',
          left: rect.left + 'px',
        };
      }
    },
    getStyles() {
      return this.task.props?.settings?.aiGenerated
        ?.map((aiItem) => aiItem?.styles)
        .join('\n\n');
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.isEditMode && this.editTaskIndex !== null) {
        const editTask =
          this.task.props?.settings?.aiGenerated[this.editTaskIndex];
        if (editTask)
          this.$refs?.chatgptInputRef?.renderDefaultValue(
            editTask.prompt,
            false
          );
      } else {
        this.$refs?.chatgptInputRef?.$refs?.editable?.focus();
      }
    });
  },

  components: {
    AskAiInput,
  },
};
</script>

<style>
.floating-ask-ai-wrapper {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: fixed;
  background-color: #8080804a;
  z-index: 1000;
}

.floating-ask-ai-wrapper .ai-dropdown {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.2);
  border: none;
  width: 333px;

  position: absolute;
}

.floating-ask-ai-wrapper .ai-dropdown input {
  width: 100%;
  height: 35px;
  color: #464d5d;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  box-sizing: border-box;
  margin: 0;
  border: none;
  padding: 10px;
}
.floating-ask-ai-wrapper .ai-dropdown input[type='text']::placeholder {
  opacity: 0.7;
  font-size: 14px;
}
.floating-ask-ai-wrapper .common-button-component {
  margin-top: 20px;
  float: right;
}

.floating-ask-ai-wrapper .error {
  color: red;
  font-size: 12px;
  margin-top: 10px;
  display: inline-block;
}

.floating-ask-ai-wrapper .ask-ai-input-wrapper {
  margin-top: 0 !important;
}
</style>
